import { IOrder } from '@/store/ducks/order/types';

export const setLocalOrder: (order: IOrder) => void = (order) => {
  if (order) {
    localStorage.setItem('order', JSON.stringify(order));
  }
};
